import API from './api'

export const exportToPDV = async (id) => {
  return API.post(`service-order/appointment/${id}/send-to-vo`)
}

export const payServices = async (id) => {
  try {
    return await API.post(`service-order/appointment/${id}/pay`)
  } catch (error) {
    return error
  }
}
